/**
 * Bridge nativo per l'app Sanità (Android WebView / iOS WKWebView), pensata per il tablet.
 * Stesso schema di Drive e Family:
 *  - user agent "AffidyaSanitarioAndroid/<ver>" oppure "AffidyaSanitarioIOS/<ver>";
 *  - sui tablet anche "AffidyaSanitarioTablet/1";
 *  - oggetto window.SanitarioApp.
 */
export const SANITARIO_UA_RE = /AffidyaSanitario(Android|IOS)\//;
export const SANITARIO_TABLET_UA_RE = /AffidyaSanitarioTablet\//;

export function isNativeSanitarioApp(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  return SANITARIO_UA_RE.test(ua || "");
}

export function isNativeSanitarioTablet(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  return SANITARIO_TABLET_UA_RE.test(ua || "");
}

export function nativeSanitarioPlatform(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  const m = (ua || "").match(SANITARIO_UA_RE);
  return m ? (m[1] === "IOS" ? "ios" : "android") : null;
}

export function getSanitarioBridge() {
  if (typeof window === "undefined") return null;
  const b = window.SanitarioApp;
  return b && typeof b === "object" ? b : null;
}

export function isLikelyWebView(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  if (isNativeSanitarioApp(ua)) return true;
  if (/; wv\)/.test(ua)) return true;
  return /(iPhone|iPad|iPod).*AppleWebKit(?!.*Safari)/.test(ua);
}

export function isStandaloneDisplay() {
  if (typeof window === "undefined") return false;
  const mq = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  return !!mq || window.navigator?.standalone === true;
}
